import React, { useState, useEffect } from "react";

interface Props {
  htmlFilePath: string;
}

const HtmlFile: React.FC<Props> = ({ htmlFilePath }) => {
  const [htmlFile, setHtmlFile] = useState("");

  useEffect(() => {
    fetch(htmlFilePath)
      .then(response => response.text())
      .then(text => setHtmlFile(text))
      .catch(error => console.error(error));
  }, [htmlFilePath]);

  return (
    <div className="pr-8" dangerouslySetInnerHTML={{ __html: htmlFile }} />
  );
};

export default HtmlFile;
